<template>
  <div class="home">
    <div class="loginBox column">
      <!-- <el-image :src="logo" class="logoImg" /> -->
      <div class="inp center">
        <span class="iconfont yz-guanliyuan"></span>
        <el-input
          v-model="input"
          style="flex: 1;"
          placeholder="请输入账号"
          @keydown.enter="login"
        />
      </div>
      <div class="inp center">
        <span class="iconfont yz-guanliyuan"></span>
        <el-input
          v-model="pas"
          style="flex: 1;"
          type="password"
          placeholder="请输入密码"
          show-password
          @keydown.enter="login"
        />
      </div>
      <el-button class="loginbut" type="primary" @click="login">登录</el-button>
    </div>
  </div>
</template>

<script>
//   import logo from "@/assets/images/logo.png";

export default {
  name: "Login",
  data() {
    return {
      input: "", // 账号
      pas: "", // 密码
    };
  },
  methods: {
    login() {
      // 登录逻辑
      if (this.input !== "" && this.pas !== "") {
        if (this.input === "admin" && this.pas === "123456") {
          this.$router.push({ name: "information" }); // 登录成功，跳转到信息页面
        } else {
          this.message.error("账号密码错误", "登录失败", {
            type: "warning",
          });
        }
      } else {
        this.message.error("请输入账号密码", "登录失败", {
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  height: 100%;
  background: url("../assets/img/logobg.jpg") no-repeat;
  background-size: 100% 110%;
  display: flex;
  justify-content: center;
  align-items: center;
  .loginBox {
    width: 480px;
    height: 550px;
    flex-shrink: 0;
    border-radius: 4px;
    background: #fff;
    padding: 110px 90px;
    .inp {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #d9d9d9;
      cursor: pointer;
      .iconfont {
        font-size: 30px;
        color: #bdbdbd;
      }
      ::v-deep .el-input,
      ::v-deep .el-input__wrapper,
      ::v-deep .el-input__inner {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        font-size: 16px;
      }
      &:hover {
        border-bottom: 1px solid #2f7bf3;
      }
    }
    .loginbut {
      width: 100%;
      height: 48px;
      margin-top: 20px;
    }
  }
}
</style>
